import type { Trip } from '../../models/Trip.model.ts';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, data, user_id, created_at, updated_at`;

export class TripRepository extends SupabaseRepository<Trip> {
  constructor(client: SupabaseClient) {
    super('trips', selector, client);
  }
}

